export default "__VITE_ASSET__D19qsUmB__"